package us.laantech.common.dto

import kotlinx.serialization.Serializable


@Serializable
data class UnitedStatesPostalAddress(
//    @field:Schema(pattern = "^[A-Za-z0-9\\s]+$")
    val streetAddr1: String? = null,

//    @field:Schema(pattern = "^[A-Za-z0-9\\s]+$")
    val streetAddr2: String? = null,

//    @field:Schema(pattern = "^[A-Za-z\\s]+$")
    val city: String? = null,

//    @field:Schema(pattern = "^[A-Z]{2}$")
    val state: UnitedStatesState? = null,

//    @field:Schema(pattern = "^\\d{5}(?:-[\\d]{4})?$")
    val zip: String? = null,

//    @field:Schema(pattern = "^\\d{4}$")
    val zipExt: String? = null,
){

    init {
        zip?.let {
            require(it.matches(Regex("^\\d{5}(?:-[\\d]{4})?$"))) { "Invalid zip code format" }
        }

        zipExt?.let {
            require(it.matches(Regex("^\\d{4}$"))) { "Invalid zip extension format" }
        }
    }

    override fun toString(): String {
        return "$streetAddr1 $streetAddr2, $city, $state $zip-$zipExt"
    }

}

enum class UnitedStatesState(val displayName: String) {
    AL("Alabama"),
    AK("Alaska"),
    AZ("Arizona"),
    AR("Arkansas"),
    CA("California"),
    CO("Colorado"),
    CT("Connecticut"),
    DE("Delaware"),
    DC("District of Columbia"),
    FL("Florida"),
    GA("Georgia"),
    HI("Hawaii"),
    ID("Idaho"),
    IL("Illinois"),
    IN("Indiana"),
    IA("Iowa"),
    KS("Kansas"),
    KY("Kentucky"),
    LA("Louisiana"),
    ME("Maine"),
    MD("Maryland"),
    MA("Massachusetts"),
    MI("Michigan"),
    MN("Minnesota"),
    MS("Mississippi"),
    MO("Missouri"),
    MT("Montana"),
    NE("Nebraska"),
    NV("Nevada"),
    NH("New Hampshire"),
    NJ("New Jersey"),
    NM("New Mexico"),
    NY("New York"),
    NC("North Carolina"),
    ND("North Dakota"),
    OH("Ohio"),
    OK("Oklahoma"),
    OR("Oregon"),
    PA("Pennsylvania"),
    RI("Rhode Island"),
    SC("South Carolina"),
    SD("South Dakota"),
    TN("Tennessee"),
    TX("Texas"),
    UT("Utah"),
    VT("Vermont"),
    VA("Virginia"),
    WA("Washington"),
    WV("West Virginia"),
    WI("Wisconsin"),
    WY("Wyoming"),
}


